import { COMPANY_TIME_ZONE } from '../../constants';

// Formatting shared by the dashboard cards. Every 'YYYY-MM-DD' is a calendar day and is
// formatted in UTC, its own day, never through the browser's zone (see utils/dateUtils.js);
// every instant is shown in company time, as the attendance pages do.

const DAY_MONTH = { day: 'numeric', month: 'short', timeZone: 'UTC' };

/** '2026-11-02' as "2 Nov". */
export function formatDay(day) {
  return new Date(`${day}T00:00:00Z`).toLocaleDateString('en-GB', DAY_MONTH);
}

/** '2026-11-02' as "Mon, 2 Nov". */
export function formatShortDay(day) {
  return new Date(`${day}T00:00:00Z`).toLocaleDateString('en-GB', {
    weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC',
  });
}

/** '2026-11-02' as "Monday, 2 November". */
export function formatLongDay(day) {
  return new Date(`${day}T00:00:00Z`).toLocaleDateString('en-GB', {
    weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC',
  });
}

/** A leave's days: "2 Nov", "2 - 4 Nov" or "30 Oct - 2 Nov". */
export function formatDayRange(start, end) {
  if (!end || start === end) return formatDay(start);
  if (start.slice(0, 7) === end.slice(0, 7)) {
    return `${Number(start.slice(8, 10))} - ${formatDay(end)}`;
  }
  return `${formatDay(start)} - ${formatDay(end)}`;
}

/** An instant as "9:05 AM" in `timeZone` (company time by default). */
export function formatClock(instant, timeZone = COMPANY_TIME_ZONE) {
  return new Date(instant).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone });
}

/** Minutes as "6h 05m". */
export function formatMinutes(minutes) {
  const whole = Math.max(0, Math.floor(minutes || 0));
  return `${Math.floor(whole / 60)}h ${String(whole % 60).padStart(2, '0')}m`;
}

/** "Good morning" / "Good afternoon" / "Good evening" by the company's clock. */
export function greetingFor(now = new Date()) {
  const hour = Number(new Intl.DateTimeFormat('en-US', {
    hour: 'numeric', hourCycle: 'h23', timeZone: COMPANY_TIME_ZONE,
  }).format(now));
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

/** Up to two initials for an avatar. */
export function initials(firstName, lastName) {
  return `${(firstName || '').trim().charAt(0)}${(lastName || '').trim().charAt(0)}`.toUpperCase() || '?';
}

export const fullName = (person) => [person.first_name, person.last_name].filter(Boolean).join(' ');
